import React from 'react'
import Ink from 'react-ink';
import { connect } from 'react-redux'
import { hashHistory } from 'react-router'
import { continueObjectManagementOpen } from '../../actions/keyFunctionActions'
import { setMessageBarText } from '../actions/objectManagementActions'
import { resetInputQuantity } from '../../actions/receiptActions'
import { getObjectItemByNumber, getTranslation } from '../../actions/dataActions'
import * as resource from '../../constants/Resources'
import PropTypes from 'prop-types'

class MessageBar extends React.Component {
    constructor(props) {
        super(props)
        this.returnTap = this.returnTap.bind(this);
        this.searchTap = this.searchTap.bind(this);
    }

    returnTap() {
        hashHistory.push('/overview');
    }

    searchTap() {
        if (this.props.number > 0) {
            const selecteditem = this.props.getObjectItemByNumber(parseInt(this.props.number, 10));

            if (selecteditem != null) {
                this.props.continueObjectManagementOpen(selecteditem);
                this.props.resetInputQuantity();
            }
            else {
                this.props.setMessageBarText(this.props.getTranslation(resource.OBJECT_NOT_FOUND));
            }
        } else {
            this.props.setMessageBarText(this.props.getTranslation(resource.ENTER_OBJECT_NUMBER));
        }
    }

    render() {
        return (
            <div id="messagebar">
                <button id="returnbutton" onClick={this.returnTap}>
                    <i className="big caret left icon"></i>
                    <Ink />
                </button>
                <div id="message">
                    {this.props.messagebartext}
                </div>
                <button id="searchbutton" onClick={this.searchTap}>
                    <i className="large caret search icon"></i>
                    <Ink />
                </button>
            </div>
        )
    }
}

MessageBar.propTypes = {
    messagebartext: PropTypes.string
}

function mapStateToProps(state) {
    return {
        messagebartext: state.objectManagementState.messagebartext,
        number: state.receiptState.input.inputquantity,
        objectgroups: state.objectManagementState.objectgroups
    }
}

export default connect(mapStateToProps, {
    setMessageBarText,
    continueObjectManagementOpen,
    resetInputQuantity,
    getObjectItemByNumber,
    getTranslation
})(MessageBar)



// WEBPACK FOOTER //
// src/objectmanagement/components/MessageBar.jsx